import Task from './Task';
import { createError } from '../error';

class ChangeUserLanguageTask extends Task {
  constructor($q, APIService, StaffUserService) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.StaffUserService = StaffUserService;
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set staffUserId(id) {
    this._staffUserId = id;
  }

  get staffUserId() {
    return this._staffUserId;
  }

  set locale(locale) {
    this._locale = locale;
  }

  get locale() {
    return this._locale;
  }

  /**
   * Public methods
   */

  populate(data) {
    this.staffUserId = data.staffUserId;
    this.locale = data.locale;
  }

  serialize() {
    return {
      staffUserId: this.staffUserId,
      locale: this.locale,
    };
  }

  execute() {
    return this.StaffUserService.changeUserLanguage(this.staffUserId, this.locale);
  }
}

export default ChangeUserLanguageTask;
